import { ROIEventType } from '../types';

export interface SessionTimingRecord {
  sessionId: string;
  timestamp: number;
  dictationSeconds: number;
  fusionSeconds: number;
}

/**
 * Agrupa eventos ROI de tipo GENERATION por sessionId (una sesión de estudio en Modular-1),
 * quedándose únicamente con el ÚLTIMO intento (mayor timestamp) de cada sesión.
 * Esto evita que regeneraciones dentro del mismo estudio infle los promedios o conteos.
 */
export function collapseGenerationEventsBySession(events: any[]): SessionTimingRecord[] {
  const bySession = new Map<string, any>();
  events.forEach((e: any) => {
    if (e.type !== ROIEventType.GENERATION) return;
    const sid = e.metadata?.sessionId;
    if (!sid || e.metadata?.dictationSeconds === undefined || e.metadata?.fusionSeconds === undefined) return;
    const existing = bySession.get(sid);
    if (!existing || e.timestamp > existing.timestamp) {
      bySession.set(sid, e);
    }
  });
  return Array.from(bySession.values()).map((e: any) => ({
    sessionId: e.metadata.sessionId,
    timestamp: e.timestamp,
    dictationSeconds: e.metadata.dictationSeconds,
    fusionSeconds: e.metadata.fusionSeconds,
  }));
}
